import { testimonials } from '@/mocks/shows';

export default function Testimonials() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            用户口碑
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            听听他们怎么说星辰影院
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 rounded-xl bg-background-50"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-primary-500 text-sm"></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                "{item.content}"
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <span className="text-sm font-medium text-foreground-800">{item.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}